import React from 'react';
import { Link } from 'react-router-dom';
import { slots } from '../data/slots';
import { providers } from '../data/providers';
import { MailIcon } from 'lucide-react';
import { CONTACT_EMAIL } from '../data/contact';
import { trackEvent } from '../utils/analytics';
export function SiteFooter() {
  return <footer className="mt-24 bg-ink text-white/80" data-id="element-271" data-mp="3hheqq31uhrug">
      <section id="verantwoord" className="border-b border-white/10" data-id="element-272" data-mp="3hglqzm1b02lt">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 lg:grid-cols-[1.4fr_1fr]" data-id="element-273" data-mp="3difoiq7i096p">
          <div data-id="element-274" data-mp="38g6vjtuml74l">
            <h2 className="font-serif text-2xl font-semibold text-white" data-id="element-275" data-mp="38jupuv7w9xkd">Verantwoord gokken</h2>
            <p className="mt-3 max-w-2xl leading-relaxed" data-id="element-276" data-mp="33kri330j5d8p">
              Slots zijn entertainment, geen manier om geld te verdienen. Bepaal vooraf een budget en een tijdslimiet,
              en speel nooit om verliezen terug te winnen. Probeer een slot eerst gratis in de demo.
            </p>
          </div>
          <div className="rounded-xl bg-white/5 p-5" data-id="element-277" data-mp="wqea1vr9b8da">
            <p className="text-sm text-white/70" data-id="element-278" data-mp="15pu094blyd1p">Hulp nodig? Gratis en vertrouwelijk, 24/7.</p>
            <p className="mt-1 font-serif text-xl font-semibold text-white" data-id="element-279" data-mp="1aqzp2r25dg5y">Gambling Helpline NZ</p>
            <a href="tel:0800654655" className="mt-1 block text-lg font-semibold text-white hover:underline" data-id="element-280" data-mp="vtqvdqpdg0b2">
              0800 654 655
            </a>
            <a href="https://www.gamblinghelpline.co.nz" target="_blank" rel="noopener noreferrer" className="mt-1 block text-sm text-white/70 underline-offset-2 hover:text-white hover:underline" data-id="element-281" data-mp="1ohcykxuot2xe">
              gamblinghelpline.co.nz
            </a>
          </div>
        </div>
      </section>

      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-282" data-mp="1jp20m0jibr7h">
        <div data-id="element-283" data-mp="27ew9y84maxmz">
          <p className="font-serif text-2xl font-semibold text-white" data-id="element-284" data-mp="27e4h352ene0e">
            Slot<span className="text-oranje" data-id="element-285" data-mp="2c8ibp598th40">Gids</span>
          </p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed" data-id="element-286" data-mp="2m362fv5jclp4">
            De Nederlandse gids voor online slots in Nieuw-Zeeland. Onafhankelijk beoordeeld, maandelijks bijgewerkt.
          </p>
          <a href={`mailto:${CONTACT_EMAIL}`} onClick={() => trackEvent('contact_click', {
          topic: 'footer'
        })} className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-white underline-offset-2 hover:underline" data-id="element-287" data-mp="2d1q0mbssdrwi">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-288" data-mp="1ydbt3nkfdf9m" />
            {CONTACT_EMAIL}
          </a>
        </div>
        <div data-id="element-289" data-mp="1tdqrf5dvest7">
          <h3 className="text-sm font-semibold text-white" data-id="element-290" data-mp="1tdgxj6ppg1i8">Top 5 slots</h3>
          <ul className="mt-3 space-y-2 text-sm" data-id="element-291" data-mp="1pcx5uinwhq3h">
            {slots.slice(0, 5).map(s => <li key={s.slug} data-id="element-292" data-mp="1kdaru70905tm">
                <Link to={`/slots/${s.slug}`} className="hover:text-white" data-id="element-293" data-mp="1kciv2sux021r">
                  {s.name}
                </Link>
              </li>)}
          </ul>
        </div>
        <div data-id="element-294" data-mp="3r2m79smm7s1x">
          <h3 className="text-sm font-semibold text-white" data-id="element-295" data-mp="3r0rn4gj643yw">Providers</h3>
          <ul className="mt-3 space-y-2 text-sm" data-id="element-296" data-mp="3w0e8xed2asjb">
            {providers.slice(0, 5).map(p => <li key={p.slug} data-id="element-297" data-mp="4u34d88uf9n8">
                <Link to={`/providers/${p.slug}`} className="hover:text-white" data-id="element-298" data-mp="4vxm6dotiln3">
                  {p.name} slots
                </Link>
              </li>)}
          </ul>
        </div>
        <div data-id="element-299" data-mp="38cmk5bac4n15">
          <h3 className="text-sm font-semibold text-white" data-id="element-300" data-mp="38d64szrddpiv">SlotGids</h3>
          <ul className="mt-3 space-y-2 text-sm" data-id="element-301" data-mp="3dbhf1blku21m">
            <li data-id="element-302" data-mp="3d81w1xos88ux"><Link to="/#methode" className="hover:text-white" data-id="element-303" data-mp="3d820qazq8x19">Hoe wij beoordelen</Link></li>
            <li data-id="element-304" data-mp="3ha6pavbbj3h1"><Link to="/providers" className="hover:text-white" data-id="element-305" data-mp="3ha6nqqvo6vex">Providers</Link></li>
            <li data-id="element-306" data-mp="3m4ufcylz05xq"><Link to="/#verantwoord" className="hover:text-white" data-id="element-307" data-mp="3m4ugx31mcdzu">Verantwoord gokken</Link></li>
            <li data-id="element-308" data-mp="2pir5f915buui"><Link to="/#faq" className="hover:text-white" data-id="element-309" data-mp="2pir3v4lhzmse">Veelgestelde vragen</Link></li>
            <li data-id="element-310" data-mp="2tkm6qdj2u88a"><Link to="/contact" className="hover:text-white" data-id="element-311" data-mp="2tkccueuwvgxb">Contact</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-312" data-mp="25iqvzzwkrr54">
        <p className="mx-auto max-w-7xl px-4 py-6 text-xs leading-relaxed text-white/60 sm:px-6" data-id="element-313" data-mp="25k1yzxi74uv6">
          18+. SlotGids kan een vergoeding ontvangen wanneer je via onze links een account opent bij een casino. Dit
          heeft geen invloed op de SlotGids Score of de volgorde van de Top 30. RTP-waarden zijn de standaardwaarden
          van de provider; casino’s kunnen een lagere versie aanbieden. © 2026 SlotGids.co.nz
        </p>
      </div>
    </footer>;
}